import React from "react";
import "./index.css";
import { useDocTitle } from "../../components/CustomHook";

const Privacy = () => {
  useDocTitle("Application Privacy Policy | TLAppsHub");
  return (
    <div className="container">
      <h1>Privacy Policy</h1>
      <p>Last updated: 02 October 2025</p>
      <p>TLAppsHub ("we", "our", "us"), whose legal entity is Mai Van Tien, is a mobile app development studio committed to protecting your privacy and ensuring transparency. This Privacy Policy governs all applications developed and offered by us (collectively, the "Apps"), including, but not limited to, the utility app VidGet: All Video Downloader, and our various Health & Wellness and Photo Editing applications.</p>
      <p>This Privacy Policy explains what data we collect, how we use it, and your rights. By using our applications, you agree to this Privacy Policy.</p>

      <h2>1. What Data Do We Collect?</h2>
      <p>We collect several different types of information for various purposes to provide and improve our service to you.</p>

      <h3>Data You Provide (Health and Wellness Data)</h3>
      <ul>
        <li><strong>Health and Wellness Data:</strong> We collect specific user-provided health and wellness data necessary for the app's core functionality, including <strong>Blood Pressure</strong>, <strong>Heart Rate</strong>, <strong>Blood Sugar</strong>, and <strong>Weight/BMI</strong> entries. This data is input directly by you.</li>
      </ul>

      <h3>Data Automatically Collected</h3>
      <ul>
        <li><strong>Device Information:</strong> device identifier, operating system, app version.</li>
        <li><strong>Usage Data:</strong> interactions within our apps, including features you use and frequency of use.</li>
        <li><strong>Uploaded Content (Photos):</strong> if you use features that require uploading photos, your photos are processed temporarily on our servers for functionality (e.g., background removal, AI editing, try-on). They are automatically deleted immediately after processing and are never stored permanently.</li>
      </ul>

      <h2>2. How We Use Your Data</h2>
      <ul>
        <li><strong>To provide Health Tracking Services:</strong> We use your user-provided <strong>Health and Wellness Data (Blood Pressure, Heart Rate, Blood Sugar, Weight/BMI)</strong> exclusively to track, visualize, and manage your personal health progress within the app.</li>
        <li>To provide and improve app features.</li>
        <li>To analyze usage trends and enhance user experience.</li>
        <li>To ensure app stability, performance, and security.</li>
      </ul>

      <h2>3. What Data Is Shared with Third Parties?</h2>
      <p>We only share limited data with trusted third-party analytics and advertising services (such as Google Analytics, Firebase, AppMetrica, etc.):</p>
      <ul>
        <li>Device identifiers.</li>
        <li>Usage and interaction data.</li>
      </ul>
      <p><strong>Commitment on Health Data:</strong> We commit that your sensitive <strong>Health and Wellness Data (Blood Pressure, Heart Rate, Blood Sugar, Weight/BMI)</strong> is <strong>NEVER</strong> shared, sold, or disclosed to any third parties for advertising, marketing, or business purposes.</p>
      <p>We do not sell your personal information to any third parties.</p>

      <h2>4. Data We Do Not Collect or Retain</h2>
      <ul>
        <li><strong>Photos:</strong> Your photos are automatically deleted immediately after processing and are never stored permanently.</li>
        <li><strong>Facial Data:</strong> We do not store, analyze, or retain biometric identifiers or facial recognition data.</li>
        <li><strong>Personal Identifiable Information (PII):</strong> We do not collect your email address, name, phone number, or any other personal data, unless you voluntarily provide it for customer support.</li>
      </ul>

      <h2>5. Your Rights</h2>
      <ul>
        <li>Access the data we collect about you.</li>
        <li>Request deletion of your data.</li>
        <li>Opt-out of analytics or advertising tracking (via your device settings or app permissions).</li>
      </ul>

      <h2>6. Data Security</h2>
      <p>We use industry-standard security measures to protect your data. However, please note that no system is 100% secure, and we cannot guarantee absolute protection.</p>

      <h2>7. Children’s Privacy</h2>
      <p>Our services are not directed to children under 13 (or under the minimum legal age in your country). We do not knowingly collect personal data from children. If you believe we have collected such information, please contact us so we can delete it.</p>

      <h2>8. Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. Any changes will be posted within our applications and/or on our website. Continued use of our services after changes indicates your acceptance of the updated policy.</p>

      <h2>9. Contact Information</h2>
      <p>If you have any questions or concerns regarding this Privacy Policy, please contact us:</p>
      <p>Publisher: TLAppsHub</p>
      <p>Email: tlappshub@gmail.com</p>

      <h2>10. Important Medical Disclaimer</h2>
      <p><strong>This application is a self-management and data-logging tool only. It is NOT a certified medical device and is NOT intended for medical use, diagnosis, treatment, or cure of any disease. Always seek a doctor’s advice for any medical questions. Do not use the app's data as a substitute for professional medical advice.</strong></p>
    </div>
  );
};

export default Privacy;
